// Lightweight GA4 wrapper. No-op if REACT_APP_GA_ID is not set.
const GA_ID = process.env.REACT_APP_GA_ID;

function injectGtag() {
  if (!GA_ID) return;
  if (window.__gtagLoaded) return;
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script1);

  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });
  window.__gtagLoaded = true;
}

export function initAnalytics() {
  try { injectGtag(); } catch {}
}

export function trackPageView(path) {
  if (!GA_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', { page_path: path });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}

export const ANALYTICS_ENABLED = !!GA_ID;

